export const fmtMoneyFull = (v) => {
  if (v === null || v === undefined || v === 0) return "\u2014";
  const a = Math.abs(v);
  if (a >= 1e12) return `$${(v / 1e12).toFixed(2)}T`;
  if (a >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `$${(v / 1e6).toFixed(1)}M`;
  return `$${v.toFixed(0)}`;
};

// value is in millions USD
export const fmtM = (m) => {
  if (m === null || m === undefined) return "\u2014";
  if (m === 0) return "$0";
  return fmtMoneyFull(m * 1e6);
};

export const fmtPct = (v, digits = 1) => {
  if (v === null || v === undefined) return "\u2014";
  return `${v > 0 ? "+" : ""}${v.toFixed(digits)}%`;
};

export const fmtNum = (v, digits = 1) => {
  if (v === null || v === undefined) return "\u2014";
  return v.toFixed(digits);
};
